module.exports = __webpack_public_path__ + "static/media/comment-edit.cbe69f1c.svg";